<template>
  <search
    :create-route="createRoute"
    :can-create="canCreate"
    :search-route="searchRoute"
    :page-title="pageTitle"
    :sub-title="subTitle"
    :search-filter="searchFilter"
    :place-holder="placeHolder"
    :include-map="true"
    :excluded-fields="['medical_school_name', 'graduation_year', 'undergraduate_degree', 'undergraduate_degree_year',
                        'internship', 'internship_year', 'residency', 'residency_year','fellowship', 'fellowship_year',
                        'restricted_visibility']"
    :model-name="modelName"
    :isSavedSearch="isSavedSearch"
    :saved-search-info="savedSearchInfo"
    :hiddenSearch="hiddenSearch"
    :is-subscribed="isSubscribed"
>
    <template slot="results" slot-scope="{ items }">
        <div
            v-if="hiddenSearch"
            class="py-6"
        >
            <hidden-tab
                attribute-name="surgeons"
                attribute-title="Surgeons"
                :attribute-count="surgeonCount"
            >
            </hidden-tab>
        </div>
        <ul
            v-else
            class="mt-4 bg-white"
        >
            <li
            class="flex-1 min-w-0 px-4 md:grid md:grid-cols-6 md:gap-4"
            v-for="(surgeon, index) in items"
            :key="surgeon.id"
            :class="{
                'border-t border-gray-200': index > 0
            }"
            >
                <a
                    :href="surgeon.route"
                    class="col-span-5 transition duration-150 ease-in-out hover:bg-gray-50 focus:outline-none focus:bg-gray-50"
                >
                    <div class="flex items-center px-4 py-4 sm:px-6">
                        <div class="flex items-center flex-1 min-w-0">
                            <div class="flex-shrink-0">
                                <img
                                    class="w-12 h-12 rounded-full"
                                    :src="surgeon.thumbnail"
                                    alt=""
                                    loading="lazy"
                                >
                            </div>
                            <div class="flex-1 min-w-0 px-4 md:grid md:grid-cols-5 md:gap-4">
                                <div class="col-span-3 space-y-1">
                                    <div class="flex space-x-2 text-sm font-semibold leading-5 text-blue-900 truncate hover:text-blue-700 lg:text-md visited:text-indigo-800">
                                        <span v-html="surgeon.name_edge_ngram"></span>
                                        <span
                                            v-if="surgeon.primary_specialty"
                                            class="text-sm font-normal text-gray-600"
                                        >
                                            {{ surgeon.primary_specialty }}
                                        </span>
                                        <span
                                            v-if="surgeon.npi"
                                            class="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium leading-4 tracking-wide bg-gray-100 text-gray-800"
                                        >
                                            NPI: <p v-html="surgeon.npi"></p>
                                        </span>
                                        <svg v-if="isFavorite(surgeon.id)"
                                        xmlns="http://www.w3.org/2000/svg" class="w-5 h-5 text-yellow-300" viewBox="0 0 20 20" fill="currentColor">
                                            <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                                        </svg>
                                    </div>
                                    <div class="sm:flex">
                                        <div
                                            v-if="surgeon.city_state"
                                            class="flex items-center text-sm leading-5 text-gray-500 sm:mt-0"
                                        >
                                            <svg
                                                class="flex-shrink-0 mr-1.5 h-5 w-5 text-gray-400"
                                                viewBox="0 0 20 20"
                                                fill="currentColor"
                                            >
                                                <path
                                                    fill-rule="evenodd"
                                                    d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z"
                                                    clip-rule="evenodd"
                                                />
                                            </svg>
                                        <p v-html="surgeon.city_state_edge_ngram"></p>
                                        </div>

                                    </div>
                                </div>
                                <div class="hidden col-span-2 md:block">
                                    <div>
                                        <div
                                            v-if="surgeon.primary_practice"
                                            class="flex items-center text-sm font-medium leading-5 text-gray-900 truncate"
                                        >
                                            Primary Practice:
                                            <span
                                                class="ml-1 font-normal text-gray-500 truncate"
                                            >
                                                {{ surgeon.primary_practice }}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </a>
                <div class="col-span-1 flex w-full">
                <button @click="showNotesModal(surgeon.notes)" class="inline-flex rounded-full hover:bg-gray-50 p-2">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="h-4 w-4 text-gray-500">
                      <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m2.25 0H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9Z" />
                    </svg>
                    <p class="text-xs text-gray-500 ml-1">
                      View Notes <span class="bg-blue-100 text-blue-700 items-center px-2 py-0.5 rounded-full text-xxs font-medium leading-4 tracking-wide">{{ surgeon.notes.length }}</span>
                    </p>
                </button>
            </div>
            </li>
        </ul>
        <tw-modal ref="notes_modal">
        <template v-slot:content>
          <div class="w-full px-4 pt-5 pb-4 bg-white sm:p-6 sm:pb-4">
            <div class="w-full sm:flex sm:items-start">
                <div class="flex items-center justify-center flex-shrink-0 p-2 mx-auto bg-gray-100 rounded-full w-14 h-14 sm:mx-0 sm:h-10 sm:w-10">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-10 h-10 mx-auto text-gray-400">
                      <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m2.25 0H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9Z" />
                    </svg>
                </div>
                <div class="w-full mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
                    <h3 class="text-lg leading-6 text-gray-600">
                      Notes
                    </h3>
                    </div>
                    </div>
                    <div class="w-full mt-3">
                      <ul v-if="surgeonNotes.length > 0" class="mt-2 overflow-y-scroll border-gray-200 rounded-lg border-1 max-h-44">
                          <li
                              v-for="(note, index) in surgeonNotes"
                              :key="note.id"
                              :class="{
                                'border-t border-gray-200': index > 0
                              }"
                          >
                          <div class="flex mt-2">
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="h-4 w-4 text-gray-400 inline-flex mr-2">
                              <path stroke-linecap="round" stroke-linejoin="round" d="M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 0 1 2.25-2.25h13.5A2.25 2.25 0 0 1 21 7.5v11.25m-18 0A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75m-18 0v-7.5A2.25 2.25 0 0 1 5.25 9h13.5A2.25 2.25 0 0 1 21 11.25v7.5" />
                            </svg>

                            <p class="text-gray-400 text-xs inline-flex">
                              {{ convertToHumanReadable(note.created_at) }}
                            </p>
                          </div>
                          <div class="flex items-center px-4 py-4 sm:px-6">
                            {{ note.note }}
                          </div>
                        </li>
                      </ul>
                      <div v-else class="mt-2 overflow-y-scroll rounded-lg max-h-64">
                        <div class="p-6 text-center rounded-lg">
                            
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-12 h-12 mx-auto text-gray-400">
                            <path stroke-linecap="round" stroke-linejoin="round" d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126ZM12 15.75h.007v.008H12v-.008Z" />
                            </svg>

                            <h3 class="mt-2 text-lg font-medium text-gray-900">You haven't added any notes for this profile yet!</h3>
                            <p class="mt-1 text-gray-500 text-md">These notes are for your eyes only! Keep that rolodex up to date!</p>
                            <p class="mt-1 text-gray-500 text-md">Head to this profile to add a note.</p>
                        </div>
                      </div>
                    </div>
                </div>
          <div class="flex justify-end px-4 py-3 space-x-2 sm:space-x-4 bg-gray-50 sm:px-6">
              <button class="tw-button-gray" @click="hideNotesModal">
                  Close
              </button>
          </div>
        </template>
      </tw-modal>
    </template>
  </search>
</template>

<script>
export default {
  props: {
    createRoute: {
      type: String,
      required: false,
      default: null
    },
    canCreate: {
      type: Boolean,
      default: false,
    },
    pageTitle: {
      type: String,
      required: true,
    },
    subTitle: {
      type: String,
      required: false,
      default: null,
    },
    searchRoute: {
      type: String,
      required: true,
    },
    searchFilter: {
      type: [Array, Object],
      required: false,
    },
    modelName: {
        type: String,
        required: false,
    },
    placeHolder: {
      type: String,
      required: false,
    },
    isSavedSearch: {
        type: Boolean,
        required: false,
        default: false,
    },
    savedSearchInfo: {
        type: [Array, Object],
        required: false,
    },
    userFavorites: {
        type: [Array, Object],
        required: false,
    },
    hiddenSearch: {
        type: Boolean,
        required: false,
    },
    isGuest: {
        type: Boolean,
        required: false,
    },
    surgeonCount: {
        type: Number,
        required: false,
    },
    isSubscribed: {
        type: Boolean,
        required: false,
    }
  },
  data() {
    return {
      surgeonNotes: [],
    }
  },
  methods: {
    isFavorite(id){
        if ( this.userFavorites.includes(id) ){
            return true;
        }
        return false;
    },
    showNotesModal(notes) {
      this.surgeonNotes = notes;
      this.$refs.notes_modal.show();
    },
    hideNotesModal() {
      this.$refs.notes_modal.hide();
      this.surgeonNotes = [];
    },
    convertToHumanReadable(dateString) {
      const date = new Date(dateString);

      const options = {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        hour: 'numeric',
        minute: 'numeric',
        second: 'numeric',
        hour12: true // Use AM/PM format
      };

      return date.toLocaleString('en-US', options);
    }
  }
};
</script>
